<div>
  <mat-radio-group required [value]="userDataAcl!.accessLevel">
    <mat-radio-button *ngFor="let acl of accessLevels" [value]="acl.level" matTooltip="{{ acl.tooltip }}"
      (change)="onAccessLevelChange(acl.level)">{{ acl.label
      }}</mat-radio-button>
  </mat-radio-group>
</div>
